import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const useYoutubeChannelTabs = (
  goalUID,
  options = { fallbackData: undefined }
) => {
  const key = `youtube-channel-tabs/goalTabs/${goalUID}`;
  const { data: youtubeChannelTabsData, ...rest } = useFetch(
    key,
    { useCamelCase: true, hostType: HOST_TYPE.CMS },
    { fallbackData: options.fallbackData }
  );

  return {
    key,
    youtubeChannelTabsData,
    ...rest
  };
};

export default useYoutubeChannelTabs;
